<script setup>
defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  count: { type: [Number, String], default: null },
})
</script>

<template>
  <div class="toolbar-heading">
    <div class="toolbar-title-row">
      <h2 class="toolbar-title">{{ title }}</h2>
      <span v-if="count !== null && count !== ''" class="total-count">{{ count }}</span>
    </div>
    <p v-if="subtitle" class="toolbar-subtitle">{{ subtitle }}</p>
  </div>
</template>

<style scoped>
/* Two-line heading folded into a PageToolbar bar (title + optional count +
   subtitle). It's the tallest toolbar element and sets the bar's height; the
   bar's own min-height keeps heading-less toolbars the same height. */
.toolbar-heading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  gap: 0.125rem;
  padding: 0.25rem 0.5rem;
}

.toolbar-title-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.toolbar-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.toolbar-subtitle {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin: 0;
}

.total-count {
  font-size: 0.6875rem;
  font-weight: 600;
  color: var(--text-faint);
  background: var(--surface-overlay-2);
  padding: 0.1rem 0.4rem;
  border-radius: var(--radius-xs);
}
</style>
